import _lib from '../_lib';
import active from './active/index';
import {UserDevicesNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'devices';
  let activations = [
    {
      name: 'devices',
      test: api.messageIs(UserDevicesNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};
